module.exports = __webpack_public_path__ + "static/media/Inventory-img.65b3b507.png";